module.exports = __webpack_public_path__ + "img/business_scope.e074a3d5.png";